<template>
  <button class="UiButton is-disabled" v-bind="$attrs" disabled v-if="isLoading">
    <span class="transparent">読</span><i class="fas fa-spinner fa-pulse"></i><span class="transparent">込</span>
  </button>
  <button class="UiButton" v-bind="$attrs" @click="$emit('click')" v-else>
    <slot />
  </button>
</template>

<script>
import Card from '@/components/atoms/Card'

export default {
  name: 'UiButton',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.UiButton {
  font-weight: bold;
  padding: 0.75em;
  color: $white;
  border-radius: $round;
  background: $primary;

  &.is-disabled {
    cursor: none;
    background: $light;
    pointer-events: none;
  }
}

.transparent {
  opacity: 0;
}
</style>
